import React from 'react';
import { Form as OriginalForm } from 'antd';
export default class Form extends React.PureComponent {
    render() {
        const { forwardedRef, ...otherProps } = this.props;
        const columns = (this.props.columns || []).filter((item) => !item?.hidden);
        return React.createElement(OriginalForm, Object.assign({ ref: forwardedRef }, otherProps, { columns: columns }));
    }
}
Form.Item = (props) => {
    const { name, requiredobj, typeobj, patternobj, lenobj, validator } = props;
    const rules = [];
    if (requiredobj && requiredobj.required) {
        rules.push(requiredobj);
    }
    if (typeobj && typeobj.type) {
        rules.push(typeobj);
    }
    if (patternobj && patternobj.pattern) {
        rules.push(patternobj);
    }
    if (lenobj && (lenobj.max || lenobj.min)) {
        rules.push(lenobj);
    }
    if (validator && typeof validator === 'function') {
        rules.push({
            validator: (_, value) => validator(value),
        });
    }
    const namePath = typeof name === 'string' && name.indexOf('.') > 0 ? name.split('.') : name;
    const { children, ...other } = props;
    let node = children;
    if (Array.isArray(children) && children.length === 1) {
        node = children[0];
    }
    return (React.createElement(OriginalForm.Item, Object.assign({}, other, { name: namePath, rules: rules }), node));
};
